<!--p-messages [(value)]="messages" [enableService]="false" [closable]="false"></p-messages-->

<h3 data-cy="titulo-pagina">Pesquisar questionário profissiográfico</h3>

<sgp-filtro-pesquisar-questionario />
<sgp-resultado-questionario-profissiografico />
